/**
 * Coerce an API boolean field into a proper boolean.
 * Handles all known API representations: number (1/0), boolean (true/false), and string ("1"/"true").
 */
export function toBool(value: number | boolean | string | undefined | null): boolean {
    return value === true || value === 1 || value === '1' || value === 'true';
}
